var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"gridItem",class:{
    'gridItem--hoverable': _vm.hoverable
  },style:(_vm.style),attrs:{"id":`item-${_vm.data.media.id}`}},[(_vm.hoverable)?_c('div',{staticClass:"gridItem__overlay"},[_c('p',[_vm._v(_vm._s(_vm.groupName))])]):_vm._e(),_c('div',{ref:"inner",staticClass:"gridItem__inner"},[_vm._t("default")],2),_vm._t("downloadIcon")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }